import { BASE_URL } from '../constants/Constants';
import axiosInstance from './axiosInstance';

export const getViewById = async (viewId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/view/${viewId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching view:", error);
    return error.response.data;
    //throw error;
  }
};

export const getViewDiagramById = async (viewId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/view/preview/${viewId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching view diagram:", error);
    return error.response.data;
    //throw error;
  }
};

export const getViewsByCellId = async (cellId) => {
  try {
    
    const response = await axiosInstance.get(`${BASE_URL}/view/cell/${cellId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching views:", error);
    return error.response.data;
    //throw error;
  }
};

export const addView = async (payload) => {
  console.log(payload);
  try {
    const response = await axiosInstance.post(`${BASE_URL}/view`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating view:', error);
    return error.response.data;
    //throw error;
  }
};

export const updateView = async (payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/view`, payload);
    return response.data;
  } catch (error) {
    if (error.response?.data?.code === 'VIEW_NAME_EXISTS') {
      throw { code: 'VIEW_NAME_EXISTS' };
    }
    return error.response.data;
    //throw error;
  }
};

export const updateViewDiagram = async (payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/view/diagram`, payload);
    return response.data;
  } catch (error) {
    console.error('Error editing view diagram:', error);
    return error.response.data;
    //throw error;
  }
};

// Fetch view details along with extracted pins (no diagram_xml)
export const getViewWithPinsById = async (viewId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/view/pins/${viewId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching view with pins:", error);
    return error.response.data;
    //throw error;
  }
};

export const getViewsByViewType = async (cellId, viewTypeIds) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/view/cell/${cellId}/viewtype/${viewTypeIds.join(",")}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching views by cellId and viewTypeId(s):", error);
    return error.response.data;
    //throw error;
  }
};

export const getNetlistByViewId = async (viewId, cellName) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/netlist-validator/netlist/${viewId}/${cellName}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching netlist:", error);
    return error.response?.data;
  }
};

export const runValidation = async (schematicViewId, stickViewId) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/netlist-validator/validate/${schematicViewId}/${stickViewId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error running LVS comparison:", error);
    return error.response?.data;
  }
};
